<div class="vo-cookie-warning-banner-wrapper">
  <div class="cookie-warning-banner d-flex flex-column flex-md-row py-30 px-15 px-md-30 justify-content-between">
    <div class="text-center text-md-left mb-15 mb-md-0 mr-md-30">
      <div
        class="vo-body-bold-16"
        [innerHtml]="referenceDataLabels.CookieWarningTitle | localizeLabel | toTrustedHtml"
      ></div>
      <div
        class="vo-body-regular-16 vo-link-inside"
        [innerHtml]="referenceDataLabels.CookieWarningContent | localizeLabel | toTrustedHtml"
        (click)="goToCookiesPage()"
      ></div>
    </div>
    <div class="d-flex align-items-md-end justify-content-between">
      <button
        class="vo-secondary-button-1 vo-cookies-button mr-md-10"
        (click)="acceptCookies()"
        [innerHtml]="referenceDataLabels.Accept | localizeLabel"
      ></button>
      <button
        class="vo-secondary-button-1 vo-cookies-button"
        (click)="dismissCookies()"
        [innerHtml]="referenceDataLabels.Close | localizeLabel"
      ></button>
    </div>
  </div>
</div>
